var _path, _path2, _path3, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEyeOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17.5 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.21,2.04c2.45,1.78,3.79,4.46,3.79,4.46,0,0-3,6-8.25,6-1.75,0-3.24-.66-4.46-1.54",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.23,9.02c-1.13-1.32-1.73-2.52-1.73-2.52C.5,6.5,3.5.5,8.75.5c.62,0,1.21.08,1.76.24",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.34,4.91c.41.41.66.97.66,1.59,0,1.24-1.01,2.25-2.25,2.25-.62,0-1.18-.25-1.59-.66",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 2.78,
  y1: 12.47,
  x2: 14.72,
  y2: 0.53,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgEyeOff;